export const Paths = {
    default: '/api/customer-portal/surgeons',
    access: '/api/customer-portal/users/surgeons',
};
